import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'
import { DataPoint } from '@/jsonapi/CommonTypes'

enum ModelTypes {
  PatientWithLiveDataLatest = 'patient-with-live-data-latest',
}

enum ModelTypeNames {
  PatientWithLiveDataLatest = 'patientWithLiveDataLatest',
}

export interface PatientWithLiveDataLatestAttributes {
  firstName: string
  lastName: string
  timezone: string
  starttimestamp: number
  endtimestamp: number
  resultStartTimestamp: number
  resultEndTimestamp: number
  bodyWeight: DataPoint
  bodyTemperature: DataPoint
  oxygenSaturation: DataPoint
  pulseRate: DataPoint
  bloodPressureSystolic: DataPoint
  bloodPressureDiastolic: DataPoint
}

export interface PatientWithLiveDataLatestSchema {
  id: string
  attributes: PatientWithLiveDataLatestAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.PatientWithLiveDataLatest]: {
      attributes: {
        firstName: { type: 'string' },
        lastName: { type: 'string' },
        timezone: { type: 'string' },
        starttimestamp: { type: 'number' },
        endtimestamp: { type: 'number' },
        resultStartTimestamp: { type: 'number' },
        resultEndTimestamp: { type: 'number' },
        bodyWeight: { type: 'object' },
        bodyTemperature: { type: 'object' },
        oxygenSaturation: { type: 'object' },
        pulseRate: { type: 'object' },
        bloodPressureSystolic: { type: 'object' },
        bloodPressureDiastolic: { type: 'object' },
      },
    },
  },
}
export type GetPatientWithLiveDataLatestDto = { startTimestamp: number; endTimestamp: number }
export async function getPatientWithLiveDataLatestQuery(params: GetPatientWithLiveDataLatestDto) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record for patient with live data latest')
      return q
        .findRecords(ModelTypes.PatientWithLiveDataLatest)
        .filter(
          { attribute: 'starttimestamp', value: params.startTimestamp },
          { attribute: 'endtimestamp', value: params.endTimestamp }
        )
    })
    .catch(() => {
      console.log('fetch failed in patients with live data latest')
    })
}
